import { useEffect } from 'react'
import { io } from 'socket.io-client'

interface DoorNotificationData {
  storeId?: string | number
  kioskId?: string | number
  storeLabel?: string
  timestamp?: string
  [key: string]: unknown
}

export const useOpenDoorNotifications = (onDoorOpen?: (data: DoorNotificationData) => void) => {
  useEffect(() => {
    const url = import.meta.env.VITE_BACKEND_API_ENDPOINT || 'http://localhost:3333'

    const socket = io(url, {
      autoConnect: true,
      forceNew: false,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10_000,
      rememberUpgrade: true,
      timeout: 60_000,
      transports: ['websocket', 'polling'],
      upgrade: true,
    })

    socket.on('connect_error', (error) => {
      console.error('❌ [WebSocket] Connection error:', error)
    })

    socket.on('reconnect_error', (error) => {
      console.error('❌ [WebSocket] Reconnection failed:', error)
    })

    socket.on('door-open', (data: DoorNotificationData) => {
      if (onDoorOpen) {
        onDoorOpen(data)
      }
    })

    return () => {
      socket.disconnect()
    }
  }, [onDoorOpen])
}
